<div [class]="css"></div>
